import { State } from "../portal_client";
import moment = require("moment");
import { unloadedAsyncState } from "widgets-for-react";
import * as Immutable from "immutable"
import { QuotationRequest, Product, ProductConfiguration } from "../portal/types";

export let stateZero:State = { quotation_request: {
  required_delivery_date: {month: "", year: ""},
  project_name: "",
  project_city: "",
  project_country: "",
  project_address: ""
},
  products: unloadedAsyncState(),
  showProducts: false,
  productConfigurations: Immutable.Map<string, ProductConfiguration>(),
  selectedProductConfiguration: "0",
  isPanelOpen: false,
  isAlertTypeOpen: {
    cancelConfiguration: false,
    connectionErrorServer: false,
    connectionErrorUser: false,
    editCharacteristic: false,
    logout: false,
    quotationSubmit: false,
    deleteProduct: false
  },
  quotation_response: unloadedAsyncState(),
  language_code: "EN",
  editCharateristicId: "",
  deleteProductConfigurationKey:"",
  cachedCharacteristics: [],
  errorMessages: [],
  toRetry: { kind: "none" },
  inDarkMode: true,
}